import { Route } from '@angular/router';

import { StepGuard } from '../application/step.guard';
import { ErrorPageComponent } from '../pages/error-page/error-page.component';
import { PaymentPageDeactivateGuard } from '../pages/payment-page/payment-page-deactivate.guard';
import { SeatsSelectionPageComponent } from '../pages/seats-selection-page/seats-selection-page.component';
import { TicketsPageComponent } from '../pages/tickets-page/tickets-page.component';
import { CheckoutWrapperComponent } from '../ui/checkout/checkout-wrapper/checkout-wrapper.component';

export const appRoutes: Route[] = [
  {
    path: ':posId/checkout/:showId',
    component: CheckoutWrapperComponent,
    children: [
      /* The two steps a checkout can open on stay in the initial bundle. The router loads a route's
         component *before* it activates the parent, so a lazy chunk here would sit in front of the
         wrapper's own bootstrap and delay the first API call rather than only the first paint.
         Every later step is a chunk of its own, preloaded once the browser goes quiet. */
      {
        path: 'tickets',
        component: TicketsPageComponent,
        canActivate: [],
      },
      {
        path: 'seats-selection',
        component: SeatsSelectionPageComponent,
        canActivate: [],
      },
      /* StepGuard is a CanActivate: these are leaf routes with no children, so wiring it as
         canActivateChild meant Angular never invoked it on any of them. */
      {
        path: 'seats',
        loadComponent: () =>
          import('../pages/seats-selection-by-tickets-page/seats-selection-by-tickets-page.component').then(
            (m) => m.SeatsSelectionByTicketsPageComponent
          ),
        canActivate: [StepGuard],
        data: { preload: true },
      },
      {
        path: 'supplements',
        loadComponent: () =>
          import('../pages/supplements-page/supplements-page.component').then((m) => m.SupplementsPageComponent),
        canActivate: [StepGuard],
        data: { preload: true },
      },
      {
        path: 'add-ons',
        loadComponent: () => import('../pages/addons-page/addons-page.component').then((m) => m.AddonsPageComponent),
        canActivate: [StepGuard],
        data: { preload: true },
      },
      {
        path: 'reserving',
        loadComponent: () =>
          import('../pages/reserving-page/reserving-page.component').then((m) => m.ReservingPageComponent),
        canActivate: [StepGuard],
        data: { preload: true },
      },
      {
        path: 'payment',
        loadComponent: () => import('../pages/payment-page/payment-page.component').then((m) => m.PaymentPageComponent),
        canActivate: [StepGuard],
        canDeactivate: [PaymentPageDeactivateGuard],
        data: { preload: true },
      },
      {
        path: 'information',
        loadComponent: () =>
          import('../pages/information-page/information-page.component').then((m) => m.InformationPageComponent),
        canActivate: [StepGuard],
        data: { preload: true },
      },
      {
        path: 'overview',
        loadComponent: () =>
          import('../pages/ticket-product-assignment-page/ticket-product-assignment-page.component').then(
            (m) => m.TicketProductAssignmentPageComponent
          ),
        canActivate: [StepGuard],
        data: { preload: true },
      },
      {
        path: 'payment-error',
        loadComponent: () =>
          import('../pages/payment-error-page/payment-error-page.component').then((m) => m.PaymentErrorPageComponent),
      },
      {
        path: 'no-seats',
        component: ErrorPageComponent,
        data: {
          titleKey: 'errors.no_seats.title',
          messageKey: 'errors.no_seats.message',
        },
      },
      {
        path: '**',
        redirectTo: 'tickets',
      },
    ],
  },
  {
    path: ':posId/sub-checkout',
    loadChildren: () => import('./subscription.routes').then((m) => m.subscriptionRoutes),
  },
  {
    path: 'cart-expired',
    component: ErrorPageComponent,
    data: {
      titleKey: 'errors.cart_expired.title',
      messageKey: 'errors.cart_expired.message',
    },
  },
  {
    path: 'show-not-found',
    component: ErrorPageComponent,
    data: {
      titleKey: 'errors.show_not_found.title',
      messageKey: 'errors.show_not_found.message',
    },
  },
  {
    path: 'no-products',
    component: ErrorPageComponent,
    data: {
      titleKey: 'errors.no_products.title',
      messageKey: 'errors.no_products.message',
    },
  },
  {
    path: 'order-failed',
    component: ErrorPageComponent,
    data: {
      titleKey: 'errors.order_failed.title',
      messageKey: 'errors.order_failed.message',
    },
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('../pages/reset-password-page/reset-password-page.component').then((m) => m.ResetPasswordPageComponent),
  },
  {
    path: 'orders/:orderId/cancel',
    loadComponent: () =>
      import('../pages/cancel-order-page/cancel-order-page.component').then((m) => m.CancelOrderPageComponent),
  },
  {
    path: 'order/:orderId',
    loadComponent: () =>
      import('../pages/payment-verification-page/payment-verification-page.component').then(
        (m) => m.PaymentVerificationPageComponent
      ),
  },
  {
    path: 'reservation/:reservationCode',
    loadComponent: () =>
      import('../pages/cart-reservation-confirmation-page/cart-reservation-confirmation-page.component').then(
        (m) => m.CartReservationConfirmationPageComponent
      ),
  },
  {
    path: '**',
    component: ErrorPageComponent,
    data: {
      titleKey: 'errors.page_not_found.title',
      messageKey: 'errors.page_not_found.message',
    },
  },
];
